<template>
  <div class="box11">
    <pageTitle
      title="高标准企业级项目，还原真实开发流程"
      text="- 依托于大型项目库 -"
    />
    <div class="top-box">
      <div class="demo" v-for="(item, index) in demoList" :key="index">
        <div class="demo-content">
          <div class="demo-title">
            {{ item.num }}
            <span v-if="item.unit">{{ item.unit }}</span>
          </div>
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>

    <div class="subject-box">
      <div class="scorll-box6">
        <div class="nav-box">
          <div
            class="nav"
            :class="{ 'cur-nav': cur == index }"
            v-for="(item, index) in list"
            :key="index"
            @click="changeCur(index)"
          >
            {{ item.nav }}
          </div>
        </div>
        <!-- <div class="seize"></div> -->
      </div>
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
          ref="block"
        >
          <div class="content">
            <div class="open" @click="open(index)">
              查看全部
              <img src="../../../assets/coursePage/ai/box11/open.png" alt />
            </div>
            <div class="title-top">
              <div class="name">
                {{ item.name }}
                <p v-if="index >= 2">赠送</p>
              </div>
              <!-- <div class="toLink" v-if="item.href !== ''" @click="toLink(item)">
              <img src="../../../assets/coursePage/pythonData/box11/icon.png" alt />进入项目体验
            </div>-->
            </div>

            <div class="tag" v-if="item.tag && item.tag.length !== 0">
              <div>
                <div class="flex-box">
                  {{ item.tag[0] }}
                  <span>{{ index == 4 ? "+" : "个" }}</span>
                </div>
                <p>指标数量</p>
              </div>

              <div>
                <div class="flex-box">
                  {{ item.tag[1] }}
                  <span>亿</span>
                </div>
                <p>数据量</p>
              </div>

              <div>
                <div class="flex-box">
                  {{ item.tag[2] }}
                  <span>个</span>
                </div>
                <p>解决方案</p>
              </div>
            </div>

            <div class="tag-icon">项目介绍</div>
            <div class="main-text" v-html="item.txt"></div>
            <div class="tag-icon">技术架构</div>
            <div class="main-text">{{ item.lightPoint }}</div>
            <div class="tag-icon">项目优势</div>
            <div class="main-text">{{ item.advantage }}</div>
          </div>
        </swiper-slide>
      </swiper>

      <van-popup v-model="show" position="bottom" round>
        <div class="pop" v-if="show">
          <div class="pop-title">
            <div class="stage">
              {{ list[cur].name }}
              <p v-if="cur >= 2">赠送</p>
            </div>
            <div class="close" @click="show = false"></div>
          </div>

          <div class="tag" v-if="list[cur].tag && list[cur].tag.length !== 0">
            <div>
              <div class="flex-box">
                {{ list[cur].tag[0] }}
                <span>{{ cur == 4 ? "+" : "个" }}</span>
              </div>
              <p>指标数量</p>
            </div>

            <div>
              <div class="flex-box">
                {{ list[cur].tag[1] }}
                <span>亿</span>
              </div>
              <p>数据量</p>
            </div>

            <div>
              <div class="flex-box">
                {{ list[cur].tag[2] }}
                <span>个</span>
              </div>
              <p>解决方案</p>
            </div>
          </div>

          <div class="tag-icon">项目介绍</div>
          <div class="main-text" v-html="list[cur].txt"></div>
          <div class="tag-icon">技术架构</div>
          <div class="main-text">{{ list[cur].lightPoint }}</div>
          <div class="tag-icon">项目优势</div>
          <div class="main-text">{{ list[cur].advantage }}</div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {},

  data() {
    let that = this;
    return {
      show: false,
      demoList: [
        {
          num: "14",
          unit: "大",
          text: "行业",
        },
        {
          num: "16",
          unit: "个",
          text: "“大厂级”项目",
        },

        {
          num: "400",
          unit: "+",
          text: "业务指标",
        },
        {
          num: "220",
          unit: "+",
          text: "技术点",
        },
        {
          num: "真实",
          unit: "",
          text: "业务数据",
        },
      ],
      list: [
        {
          nav: "项目一",
          name: "新零售  离线数仓",
          href: "https://pip.itcast.cn/zhenxuanlx-bigdata?pythonzly",
          txt:
            "项目以新零售业务为背景，真实还原企业业务与需求。通过从0到1的搭建和开发流程，使学生掌握离线数仓技术栈的同时，能够极大提高需求分析与开发能力。",
          lightPoint:
            "Zookeeper + Hadoop + Hive + MySQL + Presto + Datax + DolphinSchedule",
          advantage:"技术架构主流、项目真实度高、教学设计合理、调优策略丰富"
        },
        {
          nav: "项目二",
          name: "小兔智购",
          href: "https://pip.itcast.cn/qianmian-bigdata",
         
          txt:
            "该项目以电商业务数据,为基础, 项目包含了行业业务用户标签的计算(离线标签计算,实时标签计算)，也具有数个机器学习类型的标签，包含了从部署到标签计算的全流程，能过快速的掌握用户画像系统的构建。",
          lightPoint:
            "ZooKeeper + Hadoop + Hive + Spark + Spark MLlib + SeaTunnel + Flume + Elasticsearch + MySQL + Doris + DolphinScheduler + FineBI",
          advantage :"技术前沿薪资高、业务通用适配强"
        },
        {
          nav: "项目三",
          name: "富华保险",
          href: "https://pip.itcast.cn/fuhua-bigdata",
         
          txt:
            "本项目基于一家大型连锁超市研发的大数据分析平台。黑马深度使用Presto的项目，为后续Presto相关课程的研发打下了坚实的基础，也为学员的就业拓宽了道路；真实的数据结构，复杂的SQL实现过程，学生学习以后可以达到离线数仓的高级开发水平。",
          lightPoint:
            "ClouderManager + ZooKeeper + Hadoop + Hive + Spark + MySQL + Orcale + PostgreSQL + Sqoop + DolphinScheduler",
          advantage:"业务新颖易理解、技术先进且实用、讲练结合吸收好"
        },
        {
          nav: "项目四",
          name: "电商 BI开发",
          href: "https://pip.itcast.cn/BI-bigdata?pythonzly",
          txt:
            "基于某B2B互联网电商平台为背景，根据订单信息、门店信息、店铺信息以及商品信息等进行分析，制作不同需求报表，以供业务人员和管理人员每天查看分析并制定相应的措施，为企业经营决策提供数据支撑，从而实现公司利益最大化。",
          lightPoint:
            "MySQL +Kettle + Pandas + FineReport",
          advantage:"完整的BI项目开发流程、全方面掌握FineReport报表开发、提供BI项目的全方位解决方案"
        },
        {
          nav: "项目五",
          name: "智慧出行 阿里云",
          href: "https://pip.itcast.cn/hmcx-bigdata?pythonzly",
        
          txt:
            "随着云平台的普及，越来越多的公司使用云平台来开发大数据应用。项目采用DataWorks+MaxCompute和阿里云Flink两大主流解决方案，来实现离线数仓和实时数仓搭建，使学生充分掌握云平台的使用，并提高整体开发能力。",
          lightPoint:
            "Flume + Kafka + Flink  + DataWorks + MaxCompute + Paimon + StarRocks",
          advantage:"业务新颖易理解、云平台应用就业广、离线实时全覆盖" 
        },
      ],
      cur: 0,
      scroll: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box12",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("scorll-box6")[0].scrollLeft =
              this.realIndex * 75;
          },
          click(e) {
            if (
              e.target.className == "open" ||
              (that.$refs.block &&
                e.target.className !=
                  "swiperwrap swiper-slide swiper-slide-active")
            ) {
              that.show = true;
            }
          },
        },
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },

    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 0, false);
      this.cur = index;
    },
    open() {
      this.show = true;
    },

    close() {
      this.showVideo = false;
    },
  },
};
</script>

<style lang="less" scoped>
.box11 {
  padding: 80px 0 0;
  width: 100%;
  background: #f5fcff;
  background-size: cover;
  overflow: hidden;
  .van-popup {
    max-height: calc(100vh - 80px);
  }
  .top-box {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 48px auto 0;
    justify-content: space-between;
    padding: 0 48px;
    .demo {
      display: flex;
      align-items: center;

      text-align: center;
      box-sizing: border-box;
      .demo-content {
        margin: 0 auto;
        .demo-title {
          display: flex;
          justify-content: center;
          font-size: 36px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #0080ff;
          line-height: 48px;
          span {
            font-family: PingFang SC;
            font-size: 24px;
            font-weight: normal;
            line-height: 56px;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #0080ff;
          }
        }

        .text {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #86909c;
          line-height: 40px;
          margin-top: 4px;
        }
      }
    }
  }
  .nav-box::-webkit-scrollbar {
    display: none;
    width: 0 !important;
    height: 0 !important;
    color: transparent;
  }
  .scorll-box {
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    width: 78px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }
  }
  .subject-box {
    position: relative;
    margin: 38px auto 0;
    // padding-bottom: 22px;
    width: 100%;
    overflow: hidden;
    .swiperwrap {
      width: 686px;

      margin-top: 22px;
      img {
        width: 100%;
        height: 528px;
        object-fit: cover;
        border-radius: 16px;
      }
      .projectName {
        height: 48px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
        text-align: center;
        margin: 32px auto 16px;
      }
      .projectDesc {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #86909c;
        line-height: 44px;
        background: linear-gradient(
          180deg,
          #86909c 0%,
          rgba(134, 144, 156, 0) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .btn {
        width: 180px;
        height: 56px;
        background: linear-gradient(270deg, #4eacff 0%, #2674ff 100%);
        border-radius: 32px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 56px;
        text-align: center;
        margin: 24px auto 14px;
      }
    }

    .scorll-box6 {
      overflow-x: scroll;
      transition: all 0.2s;
      width: 100%;
      display: flex;
      box-sizing: border-box;

      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        height: 0 !important;
        color: transparent;
      }
      .seize {
        width: 32px;

        flex-shrink: 0;
      }
    }
    .nav-box {
      flex-shrink: 0;
      display: flex;
      margin-right: 30px;
      justify-content: space-between;
      margin: 0 32px 0 32px;
      position: relative;
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      width: max-content;
      .nav {
        flex-shrink: 0;
        width: 138px;
        height: 68px;
        background: #ffffff;
        box-shadow: 0px 0px 8px 0px rgba(95, 89, 255, 0.12);
        margin: 10px 0;
        border-radius: 8px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 68px;
        text-align: center;
        margin-right: 20px;
      }
      .nav:last-child {
        margin-right: 32px;

        box-sizing: border-box;
      }
      .cur-nav {
        background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);
        flex-shrink: 0;
        font-weight: 600;
        color: #ffffff;
      }
    }
  }

  .swiper-pagination-box12 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    transform: translate(-50%, 0px);
    background: rgba(75, 132, 250, 0.16);

    border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: rgba(75, 132, 250, 0.16);
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #4b84fa;
    border-radius: 3px;
  }

  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 56px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .exp {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .intro {
      margin: 16px 0 42px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      margin-bottom: 24px;
      width: 170px;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      font-size: 28px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #2674ff;
      line-height: 56px;
    }

    .target {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 74px;
      p {
        text-indent: -23px;
        padding-left: 23px;
      }
    }
  }

  .subject-block {
    margin-left: 30px;
    margin-bottom: 30px;
    .block-title {
      margin-bottom: 24px;
      font-family: PingFangSC-Medium;
      font-size: 26px;
      font-weight: bold;
      letter-spacing: 0px;
      color: #333333;
    }

    p {
      position: relative;
      display: flex;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      line-height: 42px;
      letter-spacing: 0px;
      color: #485265;
      span {
        position: absolute;
        top: 15px;
        left: -20px;
        min-width: 9px;
        height: 9px;
        background-color: #ffad00;
        transform: rotate(45deg);
      }
    }

    .block-p {
      margin-left: 20px;
    }
  }
  .swiper-slide {
  }
  .content {
    position: relative;
    margin: 0 auto;
    margin-bottom: 88px;
    width: 686px;
    height: 700px;
    background: #fff;
    background-size: cover;
    box-shadow: 0px 6px 24px 0px #dbefff;

    border-radius: 20px;
    box-sizing: border-box;
    overflow: hidden;

    .title-top {
      height: 112px;
      background: linear-gradient(
        180deg,
        #e1f4ff 0%,
        rgba(225, 240, 255, 0) 100%,
        rgba(225, 240, 255, 0) 100%
      );
      border-radius: 20px;
      display: flex;
      padding-left: 32px;
      box-sizing: border-box;
      align-items: center;
      .name {
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        line-height: 48px;
        display: flex;
        align-items: center;
        p {
          width: 76px;
          height: 40px;
          background: #ffffff;
          border-radius: 8px;
          border: 1px solid #ffb650;
          margin-left: 16px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ff7d00;
          line-height: 40px;
          box-sizing: border-box;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .toLink {
        display: flex;
        align-items: center;

        padding-left: 13px;
        width: 234px;
        height: 56px;
        background-image: linear-gradient(109deg, #0ebfff 0%, #00f0ff 100%);
        border-radius: 28px;
        box-sizing: border-box;
        font-family: PingFang SC;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;

        letter-spacing: 0px;
        color: #fefeff;
        text-shadow: 0px 0px 10px #0d7eff;
        img {
          margin-right: 20px;
          width: 35px;
          height: 35px;
          box-shadow: 0px 0px 16px 0px #0492ff;
          border-radius: 50%;
        }
      }
    }

    .tag {
      margin-top: -4px;
      margin-bottom: 40px;
      font-family: PingFangSC-Semibold;
      font-size: 43px;
      font-weight: normal;
      font-stretch: normal;
      height: 60px;
      letter-spacing: 0px;
      color: #006aff;
      margin-left: 42px;
      padding-right: 50px;
      justify-content: space-between;
      div {
        display: flex;
      }
      p {
        font-size: 26px;
        color: rgba(78, 89, 105, 1);
        font-family: PingFang SC;
        line-height: 44px;
      }
      .flex-box {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0280ff;
        line-height: 44px;
        margin-right: 0;
        &::before {
          content: "";
          display: block;
          width: 8px;
          height: 8px;
          background: #0080ff;
          border-radius: 50%;
          position: relative;
          top: 50%;
          left: -12px;
          transform: translateY(-50%);
        }
      }
    }

    .tag-icon {
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0080ff;
      line-height: 44px;
      padding: 4px 24px;
      background: #e6f4ff;
      border-radius: 0px 32px 32px 24px;
      width: max-content;
      margin-bottom: 24px;
      margin-left: 32px;
    }

    .main-text {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      padding-right: 32px;
      margin-bottom: 40px;
    }

    .open {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 30px;
      width: 100%;
      height: 140px;
      // background: #fff;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 40%,
        #fff 100%
      );
      border-radius: 0px 0px 20px 20px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 36px;
      box-sizing: border-box;
      z-index: 40;

      img {
        margin-left: 8px;
        width: 32px;
        height: 32px;
      }
    }
  }

  .tag-icon {
    img {
      margin-right: 12px;
      width: 18px;
      height: 18px;
    }
    font-family: PingFangSC-Medium;
    font-size: 26px;
    font-weight: bold;
    color: #24375c;
  }

  .main-text {
    margin-top: 25px;
    padding-left: 30px;
    font-family: PingFang SC;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 38px;
    letter-spacing: 0px;
    color: #485265;
    box-sizing: border-box;
  }

  .pop-title {
    position: sticky;
    top: 0px;
    display: flex;
    justify-content: space-between;

    background: #fff;
    box-sizing: border-box;
    z-index: 50;
    align-items: center;
    height: 132px;
    padding-top: 16px;
    .stage {
      font-size: 36px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 52px;
    }
    .close {
      width: 32px;
      height: 32px;
      background: url("../../../assets/coursePage/ai/box8/close.png") no-repeat;
      background-size: cover;
    }
  }

  .pop {
    margin: 0 auto;
    padding: 0px 48px 24px 48px;
    // padding-top: 120px;

    box-sizing: border-box;
    .tag-icon {
      background: #e6f4ff;
      border-radius: 0px 32px 32px 24px;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0080ff;
      line-height: 44px;
      padding: 4px 24px;
      width: max-content;
      margin-bottom: 24px;
    }
    .tag {
      margin-top: -4px;
      margin-bottom: 40px;
      font-family: PingFangSC-Semibold;
      font-size: 43px;
      font-weight: normal;
      font-stretch: normal;
      height: 60px;
      letter-spacing: 0px;
      color: #006aff;
      margin-left: 12px;

      justify-content: space-between;
      div {
        display: flex;
      }
      p {
        font-size: 26px;
        color: rgba(78, 89, 105, 1);
        font-family: PingFang SC;
        line-height: 44px;
      }
      .flex-box {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0280ff;
        line-height: 44px;
        margin-right: 0;
        &::before {
          content: "";
          display: block;
          width: 8px;
          height: 8px;
          background: #0080ff;
          border-radius: 50%;
          position: relative;
          top: 50%;
          left: -12px;
          transform: translateY(-50%);
        }
      }
    }
    .main-text {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
      padding-left: 0;
    }
    .stage {
      display: flex;
      align-items: center;
      margin-bottom: 0px;
      p {
        width: 76px;
        height: 40px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #ffb650;
        margin-left: 16px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ff7d00;
        line-height: 40px;
        box-sizing: border-box;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .stage {
    margin-bottom: 40px;
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #006aff;
  }

  .tag {
    display: flex;
    align-items: center;
    margin-bottom: 32px;
    font-family: PingFangSC-Medium;
    font-size: 26px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #24375c;
    img {
      margin-right: 12px;
      width: 18px;
      height: 18px;
    }
  }
}
</style>
